import { api } from './auth.service';

const timelineTecnicaService = {
  // Lista eventos visíveis na timeline técnica (eventos de etapa sempre +
  // demais eventos com exibir_timeline=1)
  listar: async (negocioId) => {
    const r = await api.get(`/timeline-tecnica/negocio/${negocioId}`);
    return r.data;
  },

  // Lista TODOS os eventos da fase técnica (visíveis ou não).
  // Usado pelo modal de Eventos pra mostrar histórico completo.
  listarTodos: async (negocioId) => {
    const r = await api.get(`/timeline-tecnica/negocio/${negocioId}/todos`);
    return r.data;
  },

  // Cria anotação manual
  criarAnotacao: async (negocioId, dados) => {
    const r = await api.post(`/timeline-tecnica/negocio/${negocioId}/anotacao`, dados);
    return r.data;
  },

  // Exclui evento (lógico)
  excluirEvento: async (eventoId) => {
    const r = await api.delete(`/timeline-tecnica/evento/${eventoId}`);
    return r.data;
  },
};

export default timelineTecnicaService;
